const state = {
  zonegroupEdit: null,
  zonegroupDelete: null
}

export default state